import React, { useState } from 'react';
import { Modal } from './Modal';

interface PastSpeakerProps {
  name: string;
  description: string;
  imageUrl: string;
  role?: string;
}

export const PastSpeaker: React.FC<PastSpeakerProps> = ({
  name,
  description,
  imageUrl,
  role
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div
        onClick={() => setIsModalOpen(true)}
        className="group relative aspect-square rounded-2xl overflow-hidden cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-xl"
      >
        <img
          src={imageUrl}
          alt={name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-600/90 to-primary-600/40 opacity-0 group-hover:opacity-100 transition-all duration-300 flex flex-col justify-end p-6">
          <h3 className="text-white font-bold text-xl mb-1 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
            {name}
          </h3>
          {role && (
            <p className="text-primary-100 text-sm transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300 delay-75">
              {role}
            </p>
          )}
        </div>
      </div>

      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <div className="p-8">
          <div className="flex items-start gap-6">
            <img
              src={imageUrl}
              alt={name}
              className="w-32 h-32 rounded-xl object-cover"
            />
            <div>
              <h3 className="text-2xl font-bold text-gray-900">{name}</h3>
              {role && (
                <p className="text-primary-600 font-medium mt-1">{role}</p>
              )}
            </div>
          </div>
          <div className="mt-6">
            <h4 className="text-lg font-semibold text-gray-900 mb-2">
              À propos
            </h4>
            <p className="text-gray-600 leading-relaxed">{description}</p>
          </div>
        </div>
      </Modal>
    </>
  );
};